import React, { useEffect } from "react";
import NavbarService from "./NavbarService";

function MarriagePage() {
  const whatsappNumber = "919332283222"; 
  const whatsappMessage =
    "Hello, I want to know more about Marriage Matching services.";

  return (
    <>
    <NavbarService/>
      <div className="container mb-5" style={{marginTop:"8rem"}}>
        <div className="row justify-content-center">
            <div className="col-md-10">
            <div className="card shadow-lg border-0 p-4">
                <div className="card-body">
                <h2 className="text-center mb-3">Marriage Matching</h2>
                <p className="text-center text-muted">
                    Ensure a harmonious and prosperous marriage with our expert
                    Marriage Matching services. Using Vedic astrology, we analyze
                    compatibility and provide insights to help you make informed
                    decisions for a blessed relationship.
                </p>

                <h4 className="mt-4">What We Offer</h4>
                <ul>
                    <li>Detailed Kundli Milan (Ashtakoot & Dashakoot Matching)</li>
                    <li>Manglik Dosha analysis & remedies</li>
                    <li>Compatibility insights for health, career & family life</li>
                    <li>Personalized marriage guidance by experts</li>
                </ul>

                <div className="mt-4 p-3 bg-light rounded shadow-sm">
                  <h5 className="mb-1">
                    <span className="text-muted text-decoration-line-through">₹1100</span>{" "}
                    <span className="text-success fw-bold">₹500 / session</span>
                  </h5>
                  <small className="text-danger fw-semibold">
                    ({Math.round(((1100 - 500) / 1100) * 100)}% OFF)
                  </small>
                  <p className="text-muted mt-2 mb-0">
                    Includes Kundli analysis + compatibility report.
                  </p>
                </div>

                <div className="mt-4 d-flex gap-3">
                    <a
                    href={`https://wa.me/${whatsappNumber}?text=${encodeURIComponent(
                        whatsappMessage
                    )}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn btn-success"
                    >
                    WhatsApp Us
                    </a>
                </div>
                </div>
            </div>
            </div>
        </div>
    </div>
    </>
  
  );
}

export default MarriagePage;
